import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=594faae4"
import script from "./Translation.vue?vue&type=script&lang=ts"
export * from "./Translation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports